import './SectionCard.css';

import { getSectionsInstitutions } from '../../../services/getSectionsInstitutions';
import { useSelector } from 'react-redux';
import { filterSectionsByTitle } from '../../../utils/filterSectionsByTitle';
import { useRedirect } from '../../../hooks/useRedirect';
// Translate
import { useTranslation } from 'react-i18next';

const SectionCard = () => {
	const { t } = useTranslation();
	const { redirect } = useRedirect();
	const { institutionCode, ebooksAccess } = useSelector(
		(state) => state.institution
	);

	const dataMetasearcher = getSectionsInstitutions(
		institutionCode,
		ebooksAccess
	)[0].data;
	const dataIndependient = getSectionsInstitutions(
		institutionCode,
		ebooksAccess
	)[1].data;

	const data = [...dataMetasearcher, ...dataIndependient];
	const filteredSections = filterSectionsByTitle(data);

	return (
		<div className='sections-desktop'>
			{filteredSections.map((section, i) => (
				<div
					key={i}
					className='section-desktop-item'
					onClick={() => redirect(section.route)}
					style={{
						backgroundImage: `url(${section.bgImage})`,
					}}
				>
					<div className='new-carousel-card-label'>{t(section.title)}</div>
				</div>
			))}
		</div>
	);
};

export default SectionCard;
